<template>
  <div>
    <loader v-if="loading" class="mt-6" />
    <div v-else-if="errorMessage !== null" class="mt-6 text-center">
      <p class="mb-3"><i class="fa fa-exclamation-triangle"></i></p>
      <p class="text-sm">{{ errorMessage }}</p>
    </div>
    <div v-else-if="quantityData.length === 0 || roiData.length === 0" class="mt-6 text-center">
      <p class="mb-3"><i class="fa fa-exclamation-triangle"></i></p>
      <p class="text-sm">Unable to show stats at this time.</p>
    </div>
    <div v-else>
      <div class="flex flex-row">
        <select class="select bg-none border-none font-bold" v-model="quantityDataTimeframe">
          <option value="week">Last week &#x25BE;</option>
          <option value="month">This month &#x25BE;</option>
          <option value="year">This year &#x25BE;</option>
        </select>
        <!--        <div class="flex-column-reverse w-1/2 text-right pt-4 text-sm">
                  <i class="fa fa-map-marked-alt"></i>  Post Codes Covered: <span class="font-bold">NN13, NN16, NN17</span>
                </div>-->
      </div>
      <panel class="pt-6 mb-3">
        <div class="flex flex-row">
          <div class="w-4/5 border-r">
            <div class="flex flex-row border-b py-5">
              <div class="flex flex-col w-1/3 text-center items-center py-4 px-8 px-12 border-r">
                <p class="font-bold text-blue uppercase border-b-4 border-blue text-lg pb-2 mb-4 item-middle">Leads</p>
                <p class="font-bold text-lg">{{quantityData[quantityDataTimeframe] ? quantityData[quantityDataTimeframe].leads : ''}}</p>
              </div>
              <div class="flex flex-col w-1/3 text-center items-center py-4 px-8 px-12 border-r">
                <p class="font-bold text-blue uppercase border-b-4 border-blue text-lg pb-2 mb-4 item-middle">Excluded</p>
                <p class="font-bold text-lg text-red-dark">{{quantityData[quantityDataTimeframe] ? quantityData[quantityDataTimeframe].excluded : ''}}</p>
              </div>
              <div class="flex flex-col w-1/3 text-center items-center py-4 px-8 px-12">
                <p class="font-bold text-blue uppercase border-b-4 border-blue text-lg pb-2 mb-4 item-middle">Sent</p>
                <p class="font-bold text-lg text-green">{{quantityData[quantityDataTimeframe] ? quantityData[quantityDataTimeframe].sent : ''}}</p>
              </div>
            </div>

            <div class="flex flex-row py-5">
              <div class="flex flex-col w-1/5 text-center items-center p-6 border-r">
                <p class="font-bold text-blue uppercase border-b-4 border-blue text-xs pb-2 mb-4 item-middle">New to Market</p>
                <p class="font-bold">{{quantityData[quantityDataTimeframe] ? quantityData[quantityDataTimeframe].new_to_market : ''}}</p>
              </div>
              <div class="flex flex-col w-1/5 text-center items-center p-6 border-r">
                <p class="font-bold text-blue uppercase border-b-4 border-blue text-xs pb-2 mb-4 item-middle">Price Reduction</p>
                <p class="font-bold">{{quantityData[quantityDataTimeframe] ? quantityData[quantityDataTimeframe].price_reduction : ''}}</p>
              </div>
              <div class="flex flex-col w-1/5 text-center items-center p-6 border-r">
                <p class="font-bold text-blue uppercase border-b-4 border-blue text-xs pb-2 mb-4 item-middle">Withdrawal</p>
                <p class="font-bold">{{quantityData[quantityDataTimeframe] ? quantityData[quantityDataTimeframe].withdrawal : ''}}</p>
              </div>
              <div class="flex flex-col w-1/5 text-center items-center p-6 border-r">
                <p class="font-bold text-blue uppercase border-b-4 border-blue text-xs pb-2 mb-4 item-middle">Fallen Through</p>
                <p class="font-bold">{{quantityData[quantityDataTimeframe] ? quantityData[quantityDataTimeframe].fallen_through : ''}}</p>
              </div>
              <div class="flex flex-col w-1/5 text-center items-center p-6">
                <p class="font-bold text-blue uppercase border-b-4 border-blue text-xs pb-2 mb-4 item-middle">Unsold (all)</p>
                <p class="font-bold">{{quantityData[quantityDataTimeframe] ? quantityData[quantityDataTimeframe].unsold : ''}}</p>
              </div>
            </div>
          </div>
          <div class="w-1/5 text-center p-4 justify-center items-center flex flex-col p-8">
            <p class="text-blue uppercase text-3xl border-b-4 border-blue mb-4 font-bold pb-2">Cost</p>
            <p class="text-green font-bold text-3xl">{{quantityData[quantityDataTimeframe] ? quantityData[quantityDataTimeframe].spend.toLocaleString('en-GB', { style: 'currency', currency:'GBP' }) : '0'}}</p>
          </div>
        </div>
      </panel>
      <div class="flex flex-row pl-12">
        <p class="text-grey-dark text-xs">*The above trigger breakdown may differ slightly from actual cards/letter sent to print if there was a valid reason for non-delivery such as an invalid postcode.</p>
      </div>
      <div class="flex flex-row pl-12 pt-2">
        <p class="text-grey-dark text-xs">*This report contains data up to {{ quantityData.week.updated_at | datetime }}.</p>
      </div>
      <panel withHeader class="pt-6 mb-6 mt-10">
        <h1 slot="header" class="w-full text-lg">
          RETURN ON INVESTMENT<span class="text-sm text-grey-darker uppercase"> - results for properties taken to market:</span>
        </h1>
        <div class="flex flex-row  my-3">
          <div class="flex flex-col w-1/5 pr-6">
            <label for="period" class="text-xs flex flex-row mb-2 uppercase">Period of time</label>
            <pl-select selectClass="w-full bg-white rounded text-xs text-black" id="period" v-model="roiOptions.timeframe" @change="fetchRoiData()">
              <option value="3_month">Last 3 months - Return on investment</option>
              <option value="6_month">Last 6 months - Return on investment</option>
              <option value="9_month">Last 9 months - Return on investment</option>
              <option value="12_month">Last year - Return on investment</option>
              <option value="15_month">Last 15 months - Return on investment</option>
              <option value="18_month">Last 18 months - Return on investment</option>
              <option value="21_month">Last 21 months - Return on investment</option>
              <option value="24_month">Last 2 years - Return on investment</option>
            </pl-select>
          </div>

          <div class="flex flex-col w-1/5 pl-6">
            <label class="text-xs flex flex-row mb-2 uppercase">Your Commission Rate(%)</label>
            <input type="number" step="0.1" class="select bg-white flex flex-row rounded text-xs text-black" v-model="roiOptions.commission">
          </div>
        </div>
        <div class="flex-row pt-2">
          <p class="text-grey-dark text-xs">*This report contains data up to {{ roiData[roiOptions.timeframe].updated_at | datetime }}.</p>
          <p class="text-grey-dark text-xs pt-2">*Properties are included within the Period of Time filter based on the date the property was first added to your dataset.</p>
        </div>
        <div class="flex flex-row px-3 my-4 border-t-4 border-b-4 bg-grey-lighter">
          <div class="flex flex-col w-1/5 text-center items-center p-6 border-r">
            <p class="font-bold text-blue uppercase border-b-4 border-blue text-xs pb-2 mb-4 item-middle">spend</p>
            <p class="font-bold">
              {{roiData[roiOptions.timeframe] ? roiData[roiOptions.timeframe].spend.toLocaleString('en-GB', { style: 'currency', currency:'GBP' }) : ''}}
            </p>
          </div>
          <div class="flex flex-col w-1/5 text-center items-center p-6 border-r">
            <p class="font-bold text-blue uppercase border-b-4 border-blue text-xs pb-2 mb-4 item-middle">Properties taken to market</p>
            <p class="font-bold">
              {{roiData[roiOptions.timeframe] ? roiData[roiOptions.timeframe].properties_taken_to_market : 0}}
            </p>
          </div>
          <div class="flex flex-col w-1/5 text-center items-center p-6 border-r">
            <p class="font-bold text-blue uppercase border-b-4 border-blue text-xs pb-2 mb-4 item-middle">AVG. COMMISSION PER PROPERTY</p>
            <p class="font-bold" v-if="roiData[roiOptions.timeframe] && roiData[roiOptions.timeframe].properties_taken_to_market > 0">
              {{((roiData[roiOptions.timeframe].properties_taken_to_market_total_price / roiData[roiOptions.timeframe].properties_taken_to_market) * (roiOptions.commission / 100)).toLocaleString('en-GB', { style: 'currency', currency:'GBP' })}}
            </p>
            <p class="font-bold" v-else>
              {{ (0).toLocaleString('en-GB', { style: 'currency', currency:'GBP' })}}
            </p>
          </div>
          <div class="flex flex-col w-1/5 text-center items-center p-6 border-r">
            <p class="font-bold text-blue uppercase border-b-4 border-blue text-xs pb-2 mb-4 item-middle">Total Earnings</p>
            <p class="font-bold">
              {{roiData[roiOptions.timeframe] ? ((roiData[roiOptions.timeframe].properties_taken_to_market_total_price) * (roiOptions.commission / 100)).toLocaleString('en-GB', { style: 'currency', currency:'GBP' }) : 0}}
            </p>
          </div>
          <div class="flex flex-col w-1/5 text-center items-center p-6">
            <p class="font-bold text-blue uppercase border-b-4 border-blue pb-2 mb-4 item-middle">ROI <span class="text-xs">PER £1 SPENT</span></p>
            <p class="font-bold" v-if="roiData[roiOptions.timeframe] && roiData[roiOptions.timeframe].spend>0">
              <span class="text-green mr-2">{{roiData[roiOptions.timeframe] ? (((roiData[roiOptions.timeframe].properties_taken_to_market_total_price) * (roiOptions.commission / 100) / (roiData[roiOptions.timeframe].spend))).toLocaleString('en-GB', { style: 'currency', currency:'GBP' }) : 0}}</span>
              <span class="text-sm">({{roiData[roiOptions.timeframe] ? ((roiData[roiOptions.timeframe].properties_taken_to_market_total_price) * (roiOptions.commission / 100)).toLocaleString('en-GB', { style: 'currency', currency:'GBP' }) : 0}})</span>
            </p>
            <p class="font-bold" v-else>
              <span class="text-green">{{ (0).toLocaleString('en-GB', { style: 'currency', currency:'GBP' })}}</span>
              <span class="text-sm">({{ (0).toLocaleString('en-GB', { style: 'currency', currency:'GBP' })}})</span>
            </p>
          </div>
        </div>
      </panel>

      <panel class="pt-6 mb-6">
        <h1 class="w-full text-lg my-3 uppercase">Historic Data</h1>
        <div class="flex flex-row  mt-3">
          <div class="flex flex-col w-1/4 pr-6">
            <label for="period" class="text-xs flex flex-row mb-2 uppercase">Period of time</label>
            <pl-select selectClass="w-full bg-white rounded text-xs text-black" id="historyDataPeriod" v-model="roiOptions.propertytimeframe">
              <option value="3_month">Last 3 months</option>
              <option value="6_month">Last 6 months</option>
              <option value="9_month">Last 9 months</option>
              <option value="12_month">Last year</option>
              <option value="15_month">Last 15 months</option>
              <option value="18_month">Last 18 months</option>
              <option value="21_month">Last 21 months</option>
              <option value="24_month">Last 2 years</option>
            </pl-select>
          </div>
          <div class="flex flex-col w-1/4 pr-6">
            <label for="keyword" class="text-xs flex flex-row mb-2 uppercase">Search</label>
            <div class="bg-white border w-full px-2 flex items-center rounded overflow-hidden">
              <button @click="fetchProperties(true)">
                  <span class="w-auto flex justify-end items-center text-grey p-1">
                    <i class="fa fa-search text-grey"></i>
                  </span>
              </button>
              <input class="py-3 px-2 w-full text-xs" style="line-height: 1.25" id="keyword" type="text" v-model="roiOptions.keyword"  placeholder="Search Postcode / Price /Agent">
            </div>
          </div>
          <div class="flex flex-col w-1/4 pr-6">
            <label for="department" class="text-xs flex flex-row mb-2 uppercase">DEPARTMENT</label>
            <pl-select v-model="filters.department" name="filter_menu" id="department" select-class="bg-white rounded text-xs text-black">
              <option value="SALES-LET">Sales &amp; Lettings</option>
              <option value="Sales">Sales</option>
              <option value="Lettings">Lettings</option>
            </pl-select>
          </div>
        </div>
        <div class="flex flex-row  my-3">
         <div class="flex flex-col w-1/4 pr-6 mt-6">
            <input type="checkbox" class="green" id="takenToMarketFlag" :value="true" v-model="filters.takenToMarket">
            <label for="takenToMarketFlag"><span class="text-sm">Taken to Market</span></label>
          </div>
          <div class="flex flex-col w-1/4 pr-6 mt-6">
            <input type="checkbox" class="green" id="prospectedToFlag" :value="true" v-model="filters.prospectedToFlag">
            <label for="prospectedToFlag"><span class="text-sm">Prospected to</span></label>
          </div>
          <button type="button"
                  class="w-1/6 bg-tertiary hover:border-tertiary text-white h-10 py-2 px-6 text-sm border border-grey-lightest hover:border-transparent rounded mr-2"
                  @click="fetchProperties(true)">
            <i class="fas fa-search"></i> Search
          </button>
        </div>

        <h2 class="text-grey-dark text-sm font-medium leading-normal my-2">
          Properties may appear multiple times if marketed for sale and to let. Properties are included within the Period of Time filter based on the date the property was first added to your dataset.
        </h2>
        <loader v-if="roiLoading"></loader>
        <div v-else class="flex flex-row">
          <div class="w-full">
            <div class="flex flex-row mt-3">
              <table class="text-center table text-grey-darker flex-auto">
                <thead class="uppercase text-xs">
                <tr>
                  <th class="uppercase pb-4"  @click="sortBy('department')">department
                    <i v-if="sorting['department']==='asc'" class="fa fa-sort-up  cursor-pointer"></i>
                    <i v-else-if="sorting['department']==='desc'" class="fa fa-sort-down cursor-pointer"></i>
                    <i v-else class="fa fa-sort cursor-pointer"></i>
                  </th>
                  <th class="uppercase pb-4"  @click="sortBy('address')">property
                    <i v-if="sorting['address']==='asc'" class="fa fa-sort-up cursor-pointer"></i>
                    <i v-else-if="sorting['address']==='desc'" class="fa fa-sort-down cursor-pointer"></i>
                    <i v-else class="fa fa-sort cursor-pointer"></i>
                  </th>
                  <th class="uppercase pb-4"  @click="sortBy('price')">price
                    <i v-if="sorting['price']==='asc'" class="fa fa-sort-up cursor-pointer"></i>
                    <i v-else-if="sorting['price']==='desc'" class="fa fa-sort-down cursor-pointer"></i>
                    <i v-else class="fa fa-sort cursor-pointer"></i>
                  </th>
                  <th class="uppercase pb-4"  @click="sortBy('agent')">listing agent
                    <i v-if="sorting['agent']==='asc'" class="fa fa-sort-up cursor-pointer"></i>
                    <i v-else-if="sorting['agent']==='desc'" class="fa fa-sort-down cursor-pointer"></i>
                    <i v-else class="fa fa-sort cursor-pointer"></i>
                  </th>
                  <th class="uppercase pb-4" @click="sortBy('last-contacted')">Last contacted
                    <i v-if="sorting['last-contacted']==='asc'" class="fa fa-sort-up cursor-pointer"></i>
                    <i v-else-if="sorting['last-contacted']==='desc'" class="fa fa-sort-down cursor-pointer"></i>
                    <i v-else class="fa fa-sort cursor-pointer"></i>
                  </th>
                  <th class="uppercase pb-4"  @click="sortBy('take-to-market')">taken to market
                    <i v-if="sorting['take-to-market']==='asc'" class="fa fa-sort-up cursor-pointer"></i>
                    <i v-else-if="sorting['take-to-market']==='desc'" class="fa fa-sort-down cursor-pointer"></i>
                    <i v-else class="fa fa-sort cursor-pointer"></i>
                  </th>
                  <th class="uppercase pb-4"  @click="sortBy('black-list')">blacklist
                    <i v-if="sorting['black-list']==='asc'" class="fa fa-sort-up cursor-pointer"></i>
                    <i v-else-if="sorting['black-list']==='desc'" class="fa fa-sort-down cursor-pointer"></i>
                    <i v-else class="fa fa-sort cursor-pointer"></i>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(property, index) in filteredProperties" :key="index" class="border-l-4 border-r-4 text-sm border" :class="{'bg-grey-lighter border-green': property.linked_property_id !== null}">
                  <td class="p-4 uppercase font-bold text-right">
                    {{property.is_rental == "true" ? 'Lettings' : 'Sales'}}</td>
                  <td class="p-4">{{property.address_line1}}, {{property.address_town}}, {{property.address_postcode}}</td>
                  <td class="p-4 uppercase">{{property.price.toLocaleString('en-GB', { style: 'currency', currency:'GBP' })}}</td>
                  <td class="p-4">{{property.agent}}</td>
                  <td class="p-4">
                    {{property.last_contacted}}
                  </td>
                  <td class="p-4">
                    <i v-if="typeof property.linked_property_id =='number' && property.exclude === 0 && ( property.is_rental === property.property_rental)" class="fa fa-check text-green-light"></i>
                    <i v-else class="text-grey fa fa-times"></i>
                  </td>
                  <td class="p-4">
                    <i v-if="property.blacklist_flag" class="fa fa-check text-green-light"></i>
                    <i v-else class="text-grey fa fa-times"></i>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div class="text-center mt-4">
              <pagination :data="properties" @pagination-change-page="fetchPaginatedData" :limit="20"></pagination>
            </div>
          </div>
        </div>
      </panel>

      <panel withHeader class="pt-6 mb-6">
        <h1 slot="header" class="border-b border-grey-lighter w-full pb-3 text-lg">
          Download Data
        </h1>

        <p class="text-sm mb-6">Download all of your Auto Prospecting data in a spreadsheet. You can filter the data within the spreadsheet, and keep track of your conversions.</p>

        <div class="flex flex-wrap -mx-2 text-xs uppercase">
          <div class="w-full sm:w-1/5 px-2 mb-6">
            <label class="uppercase">From</label>
            <date-time-picker v-model="downloadParams.start_date" format="d MMMM yyyy" value-format="yyyy-MM-dd" :time-picker="false" class="block bg-white rounded border hover:border-grey focus:border-grey-dark p-2 h-10 text-sm align-middle" :max-date="downloadParams.end_date"  />
          </div>
          <div class="w-full sm:w-1/5 px-2 mb-6 border-r">
            <label class="uppercase">To</label>
            <date-time-picker v-model="downloadParams.end_date" format="d MMMM yyyy" value-format="yyyy-MM-dd" :time-picker="false" class="block w-full bg-white rounded border hover:border-grey focus:border-grey-dark p-2 h-10 text-sm" :min-date="downloadParams.start_date"  />
          </div>
          <div class="w-full sm:w-1/5 px-2 mb-6 self-center">
            <input type="checkbox" id="sent_only" v-model="downloadParams.sent_only">
            <label class="uppercase" for="sent_only">Sent to Address Only</label>
          </div>

          <div class="w-full sm:w-1/5 px-2 mb-6 d-flex self-end">
            <button class="bg-blue hover:bg-tertiary active:bg-primary text-white hover:text-white py-2 px-6 text-sm border border-tertiary hover:border-transparent rounded shadow" @click="downloadReport()">
              <loader v-if="downloadingData"></loader>
              <span v-else><i class="fas fa-download"></i> Download Data</span>
            </button>
          </div>
        </div>
      </panel>
    </div>
  </div>
</template>

<script>
import api from '@/http'
import GaugeGraph from '@/components/Graphs/GaugeGraph'
import MultipleSelectModal from '@/components/MultipleSelectModal'
import { mapState, mapActions } from 'vuex'
import moment from 'moment'
import DateTimePicker from 'vue-vanilla-datetime-picker'
import Pagination from 'laravel-vue-pagination'

export default {
  name: 'apsReportingPage',
  components: {
    GaugeGraph,
    MultipleSelectModal,
    DateTimePicker,
    Pagination
  },
  data () {
    return {
      loading: true,
      errorMessage: null,
      propertiesPerPage: 20,
      filters: {
        department: 'SALES-LET',
        onlineValuation: 'all',
        professionalValuation: 'all',
        takenToMarket: false,
        prospectedToFlag: false
      },
      quantityData: {
        week: {},
        month: {},
        quarter: {},
        year: {}
      },
      roiData: {
        '6_month': {},
        '9_month': {},
        '12_month': {},
        '15_month': {},
        '18_month': {},
        '21_month': {},
        '24_month': {}
      },
      roiLoading: true,
      quantityDataTimeframe: 'week',
      roiOptions: {
        timeframe: '3_month',
        propertytimeframe: '3_month',
        commission: 1.5,
        department: 'rs',
        result: 'all',
        keyword: ''
      },
      downloadParams: {
        start_date: moment().subtract(1, 'year').format('YYYY-MM-DD'),
        end_date: moment().format('YYYY-MM-DD'),
        sent_only: false
      },
      downloadingData: false,
      properties: {
      },
      sorting: {}
    }
  },
  watch: {
    selectedOffice () {
      this.init()
    },
    'roiOptions.propertytimeframe': {
      handler: function () {
        this.roiOptions.page = 1
      }
    },
    filters: {
      deep: true,
      handler: function () {
        this.roiOptions.page = 1
      }
    }
  },
  created () {
    this.init()
  },
  computed: {
    ...mapState(['selectedOffice']),

    filteredProperties () {
      if (!this.properties.data) {
        return []
      }
      return this.properties.data
    },
    salesPriceRange: function () {
      let output = []
      let i = 0

      for (i = 5000; i < 100000; i += 5000) {
        output.push(i)
      }

      for (i = 100000; i < 500000; i += 10000) {
        output.push(i)
      }

      for (i = 500000; i < 1000000; i += 25000) {
        output.push(i)
      }

      for (i = 1000000; i <= 10000000; i += 50000) {
        output.push(i)
      }

      return output
    }

  },
  methods: {
    ...mapActions(['displayToastNotification', 'setPageLoading']),
    init: function () {
      this.errorMessage = null
      this.loading = true
      this.setPageLoading(true)
      let quantityData = this.fetchQuantityData()
      let roiData = this.fetchAllData()

      Promise.all([quantityData, roiData]).then(() => {
        this.loading = false
        this.setPageLoading(false)
      }, () => {
        this.errorMessage = 'Unable to show stats at this time.'
        this.loading = false
        this.setPageLoading(false)
      })
    },
    fetchQuantityData: function () {
      return api.get('/aps/reports/quantity-data', {
        params: {
          network_id: this.selectedOffice.network_id,
          client_id: this.selectedOffice.client_id,
          office_id: this.selectedOffice.id
        }
      })
        .then(response => {
          this.quantityData = response.data
        })
    },
    fetchRoiData () {
      var params = {
        network_id: this.selectedOffice.network_id,
        client_id: this.selectedOffice.client_id,
        office_id: this.selectedOffice.id,
        timeframe: this.roiOptions.timeframe,
        commissionRate: this.roiOptions.commission,
        type: 'roi'
      }
      return api.get('/aps/reports/roi-data', {
        params: params
      }).then(response => {
        this.roiData = response.data['roiData']
      })
    },
    fetchProperties (reset = false) {
      if (reset) {
        this.fetchPaginatedData(1)
      } else {
        this.fetchPaginatedData()
      }
    },
    fetchAllData (reset = false) {
      this.fetchRoiData()
      this.fetchProperties(reset)
    },
    fetchPaginatedData: function (page = 1) {
      this.roiLoading = true
      return api.get('/aps/reports/roi-data', {
        params: {
          network_id: this.selectedOffice.network_id,
          client_id: this.selectedOffice.client_id,
          office_id: this.selectedOffice.id,
          timeframe: this.roiOptions.propertytimeframe,
          department: this.filters.department,
          takenToMarket: this.filters.takenToMarket,
          prospectedTo: this.filters.prospectedToFlag,
          commissionRate: this.roiOptions.commission,
          page: page,
          keyword: this.roiOptions.keyword,
          sorting: JSON.stringify(this.sorting),
          type: 'property'
        }
      })
        .then(response => {
          this.properties = response.data['properties']
        }).finally(() => {
          this.roiLoading = false
        })
    },
    paginatorChanged: function (page) {
      this.roiOptions.page = page
    },
    downloadReport: function () {
      this.downloadingData = true
      api
        .get(`/aps/reports/download-report`, {
          params: {
            office_id: this.selectedOffice.id,
            start_date: this.downloadParams.start_date ? moment(this.downloadParams.start_date).format('YYYY-MM-DD') : null,
            end_date: this.downloadParams.end_date ? moment(this.downloadParams.end_date).format('YYYY-MM-DD') : null,
            sent_only: this.downloadParams.sent_only ? 1 : 0
          },
          responseType: 'blob'
        })
        .then((response) => {
          this.downloadingData = false
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'Download Completed',
            info: 'The APS Report is being generated and will be emailed to you shortly.'
          })
        })
        .catch(() => {
          this.downloadingData = false
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-times-circle',
            title: 'Download Failed',
            info: "We're unable to produce the requested report at this time."
          })
        })
    },
    sortBy: function (columnName) {
      if (this.sorting[columnName]) {
        let direction = this.sorting[columnName]
        if (direction === 'asc') {
          // it was sorting asc, so change it to sort desc
          let newSort = {}
          newSort[columnName] = 'desc'
          this.sorting = newSort
        } else {
          // it was sorting desc, don't sort with this field now
          this.sorting[columnName] = ''
          delete this.sorting[columnName]
        }
      } else {
        // it wasn't sorting, sort it asc
        let newSort = {}
        newSort[columnName] = 'asc'
        this.sorting = newSort
      }
      // re-fetch the data for new sorting
      this.fetchProperties()
    }
  }
}
</script>

<style scoped>

.text-blue {
  color: #008BC2;
}
.border-blue {
  border-color: #008BC2;
}
.text-green {
  color: #5AB330;
}

</style>
